'use client'

import {
	listIntegrations,
	useListIntegrations as useListIntegrationsSdk,
} from '@cocoonspace/sdk-js/v2/domains/me-integrations/me-integrations'
import type { UseQueryResult } from '@tanstack/react-query'

import { useAuth } from '~/providers/auth-provider'

type ListIntegrationsData = Awaited<ReturnType<typeof listIntegrations>>

/**
 * Lists calendar integrations for the signed-in user.
 * Waits for Firebase auth to settle and skips the request when logged out —
 * otherwise the axios auth interceptor can leave the query pending forever.
 */
export const useListIntegrations = (
	options?: Parameters<typeof useListIntegrationsSdk>[0],
): UseQueryResult<ListIntegrationsData> => {
	const { isAuth, isLoading: isAuthLoading } = useAuth()

	return useListIntegrationsSdk({
		...options,
		query: {
			...options?.query,
			enabled: (options?.query?.enabled ?? true) && isAuth && !isAuthLoading,
		},
	}) as UseQueryResult<ListIntegrationsData>
}
